module.exports = __webpack_public_path__ + "img/waterpurifier22.d5084f62.jpg";